

<div mat-dialog-title class="addRiderHeader">
    {{editBookingMode ? 'Edit Passenger Details' : 'Add New Passenger'}}
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <div *ngIf="!editBookingMode" class="displayFlexCenter mb-12">
        <app-tabs (tabChangeCallback)="onTabChange($event)" [tabs]="tabData" [initialState]="tabValue"></app-tabs>
    </div>
    <div class="formBody">
        <div class="grid-container">
            <ng-container *ngFor="let rider of riderForm.controls">
                <ng-container *ngFor="let field of formConfigs">
                    <div class="displayFlex" *ngIf="field.config.visibility.visible && !['alternatePhoneCode','alternateMobile','mobile','riderType','riderTypeId','phoneCode'].includes(field.elementKey)">
                        <label class="form-label">{{field.config.displayName}} <span *ngIf="field.config.mandatory" class="mandatoryField">*</span> </label>
                        <ng-container *ngIf="rider.get(field.elementKey)">
                            <div *ngIf="field.elementKey=='name';else otherFields">

                                <app-search *ngIf="tabValue=='FirmMember' && !rider.get('name').value;else guest"
                                [customStyle]="'rider-search'" type="searchAndSelect" placeholder="Search to add employee"
                                [fetchAsyncOptions]="riderSearch" [getCustomOptionValue]="getUserOptionValue"
                                [getCustomOptionLabel]="getUserOptionLabel" (changeCallback)="onRiderSelect($event)" 
                                [riderLimitReached]="riderLimitReached"></app-search>

                                <ng-template #guest>
                                 <app-field-generator [config]="field.config" [elementKey]="field.elementKey"
                                 [inputControl]="rider.get(field.elementKey)" [styleApplied]="styleApplied"
                                 [showCross]="tabValue=='FirmMember' ? true: false"
                                 (clearFormCallback)="clearForm($event)">
                                 </app-field-generator>
                                </ng-template>
                               
                            </div>
                            <ng-template #otherFields>
                                <div>
                                    <app-field-generator 
                                    [config]="field.config"
                                    [inputControl]="rider.get(field.elementKey)"
                                    [styleApplied]="styleApplied"
                                    [elementKey]="field.elementKey"
                                    [costCenterNames]="addRiderService.costCenterNames"
                                    [departmentListName]="addRiderService.departmentListName"
                                    [ngClass]="{'disableDropdown': tabValue=='FirmMember' && field.config.disable &&  field.config.isDataPresent}"
                                   >
                                   </app-field-generator>
                                </div>
                                
                            </ng-template>
                         
                        </ng-container>
                    </div>
                    <!-- other elements  -->
                    <div *ngIf="['alternateMobile','mobile'].includes(field.elementKey)" class="displayFlex">
                        <label class="form-label">{{field.config.displayName}} <span *ngIf="field.config.mandatory" class="mandatoryField">*</span> </label>
                        <ng-container *ngIf="rider.get(field.elementKey)">
                                <div *ngIf="field.elementKey=='mobile';else alternateMobile">
                                    <app-phone-input-component [config]="field.config" [formControls]="rider.get(field.elementKey)"
                                        [inputFormControlNumber]="rider.get(field.elementKey)"
                                        [inputFormControlCode]=" field.elementKey=='phoneCode' ? rider.get('phoneCode'):rider.get('phoneCode')"
                                        (onCodeChange)="onCodeChange($event,rider.get('phoneCode'))"
                                        [dropdownWidth]="'8vw'"
                                        [riderForm]="riderForm"
                                        [maskEnable]="isMobileMaskable"
                                        [disable]="tabValue=='FirmMember' && field.config.disable &&  field.config.isDataPresent"
                                        [elementKey]="'mobile'"
                                        [editBookingMode]="editBookingMode"
                                    ></app-phone-input-component>
                                </div>

                                <ng-template #alternateMobile>
                                    <app-phone-input-component [config]="field.config" [formControls]="rider.get(field.elementKey)"
                                      [inputFormControlNumber]="rider.get(field.elementKey)"
                                      [inputFormControlCode]="rider.get('alternatePhoneCode')"
                                      (onCodeChange)="onCodeChange($event,rider.get('alternatePhoneCode'))"
                                      [dropdownWidth]="'8vw'" 
                                      [riderForm]="riderForm"
                                      [disable]="tabValue=='FirmMember' && field.config.disable &&  field.config.isDataPresent"
                                      [maskEnable]="isAlternateMobileMaskable"
                                      [elementKey]="'alternateMobile'"
                                      [editBookingMode]="editBookingMode"
                                    ></app-phone-input-component>
                                </ng-template>   
                        </ng-container>
                    </div>

                </ng-container>
            </ng-container>
            <ng-container *ngIf=" addRiderService.miscelleneousConfig?.optionalEmailForGuest && tabValue=='Guest'">
                <div class="displayFlex">
                    <span class="form-label">Send Communication</span>
                    <span class="radioGroup">
                        <app-radio-group [options]="radiolist" [defaultValue]="'Yes'" (changeCallback)="radioInputChange($event)">
                        </app-radio-group>
                    </span>
                </div>
            </ng-container>
        </div>
    </div>
</mat-dialog-content>


<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="addBtn" 
  [ngClass]="{ 'disableDropdown': !riderForm.valid}"
  (click)="addPassenger()"> {{editBookingMode ? 'Save' : 'Add'}} </button>
</mat-dialog-actions>


